// Real brand assets hosted on Emergent customer-assets (reused from gruporitual.com)
const A1 = "https://customer-assets.emergentagent.com/job_ritual-cafe-1/artifacts";
const A2 = "https://customer-assets.emergentagent.com/job_web-en-progreso/artifacts";

export const ASSETS = {
  // Hero / breakfast
  breakfast1: `${A1}/aiihhu15_RITUAL_CAFE-38.jpg`,
  breakfast2: `${A1}/bdahz2da_RITUAL_CAFE-119.jpg`,
  breakfast3: `${A1}/s1cfn8du_RITUAL_CAFE-124.jpg`,
  // Coffee
  coffee1: `${A1}/r0e2pnms_RITUAL_CAFE-17.jpg`,
  coffee2: `${A1}/br6hhkp4_PHOTO-2026-01-27-01-43-38%207.jpg`,
  // Latte art (NOTE: replace with client-approved premium photo when uploaded)
  latteArt: `${A1}/nxiuhc46_PHOTO-2026-01-27-01-43-38%209.jpg`,
  // Gastronomy
  gastro1: `${A1}/ckomm111_RITUAL_CAFE-02.jpg`,
  gastro2: `${A1}/5qbz4gmn_RITUAL_CAFE-42.jpg`,
  gastro3: `${A1}/mgy5i82j_RITUAL_CAFE-43.jpg`,
  gastro4: `${A1}/td3ujqx8_RITUAL-16.jpg`,
  pastry: `${A1}/vzze5jz4_RITUAL_CAFE-2.jpg`,
  // Finca
  finca: `${A2}/psra1quf_finca.jpeg`,
  fincaBeans: `${A2}/rloysqos_cafec%20ama.jpeg`,
  fincaCultivo: `${A2}/cshv2g7l_finca%20cafe.jpeg`,
  fincaDrying: `${A1}/o1ceh3t5_WhatsApp%20Image%202026-01-28%20at%2020.56.30.jpeg`,
  fincaPlants: `${A1}/vgjmo3lr_PHOTO-2026-01-27-01-49-39.jpg`,
  // Store
  coffeePack: `${A2}/otyt1o2m_WhatsApp%20Image%202026-01-27%20at%2020.20.35.jpeg`,
  giftCard: `${A1}/gpsnd4rx_tarjeta%20regalo.png`,
  // Locations
  lliria: `${A2}/dhfa9by8_lliria.jpeg`,
  rocafort: `${A1}/6xr2c2m3_rocafort.jpeg`,
  rocafortInterior: `${A2}/4ofq3xpi_rocafort.jpeg`,
  valterna: `${A2}/4ofq3xpi_rocafort.jpeg`,
  // Team
  noel: `${A2}/8129s6cv_noel.jpeg`,
  jagtar: `${A1}/3byj9mri_jagtar%202.JPG`,
};

export const LINKS = {
  instagramRitual: "https://www.instagram.com/_ritualcafe",
  instagramNaguara: "https://www.instagram.com/naguaracafes",
  naguaraWeb: "https://naguaracafes.com",
  whatsappLliria: "34644936286",
  phone: "+34 960 419 855",
  phoneTel: "+34960419855",
  email: "info@gruporitual.com",
};
